import yanghuchaxun from "@/components/yanghuzuoyechaxun/yanghupaigong/";
import xunjianchaxun from "@/components/yanghuzuoyechaxun/xunjianpaigong/";
import xiaoxiuchaxun from "@/components/yanghuzuoyechaxun/xiaoxiupaigong/";
import yingjichaxun from "@/components/yanghuzuoyechaxun/yingjipaigong/";
import gaoweichaxun from "@/components/yanghuzuoyechaxun/gaoweishenqing";

import renyuanpaiban from "@/components/yhgl/renyuanpaiban";
import daibanchuli from "@/components/yhgl/daibanchuli";
import daibanxuncha from "@/components/yhgl/daibanxuncha";
import daibanchuli1 from "@/components/yhgl/daibanchuli1";
import daibanchuli2 from "@/components/yhgl/daibanchuli2";
import daibanchuligaowei from "@/components/yhgl/daibanchuligaowei";
import yibanchuli from "@/components/yhgl/yibanchuli";
import yibanxuncha from "@/components/yhgl/yibanxuncha";
import yibangaowei from "@/components/yhgl/yibanchuligaowei";
import yibanchuli1 from "@/components/yhgl/yibanchuli1";
import yibanchuli2 from "@/components/yhgl/yibanchuli2";
import form from "@/components/yhgl/form";
import xunchajilu from "@/components/yhgl/xunchajilu";
import baojiejilu from "@/components/yhgl/baojiejilu";

import yanghupaigong from "@/components/zuoyepaigong/yanghupaigong/";
import xunchapaigong from "@/components/zuoyepaigong/xunchapaigong/";
import xiaoxiupaigong from "@/components/zuoyepaigong/xiaoxiupaigong/";
import yingjipaigong from "@/components/zuoyepaigong/yingjipaigong/";
import gaoweishenqing from "@/components/zuoyepaigong/gaoweishenqing";


var data = [
  {
    path: "/yanghuchaxun",
    component: yanghuchaxun
  },
  {
    path: "/xunjianchaxun",
    component: xunjianchaxun
  },
  {
    path: "/xiaoxiuchaxun",
    component: xiaoxiuchaxun
  },
  {
    path: "/gaoweichaxun",
    component: gaoweichaxun
  },
  {
    path: "/yingjichaxun",
    component: yingjichaxun
  },
  {
    path: "/xunchajilu",
    component: xunchajilu
  },
  {
    path: "/baojiejilu",
    component: baojiejilu
  },
  {
    path: "/renyuanpaiban",
    component: renyuanpaiban
  },
  {
    path: "/form",
    component: form
  },
  {
    path: "/daibanchuli",
    component: daibanchuli
  },
  {
    path: "/daibanxuncha",
    component: daibanxuncha
  },
  {
    path: "/daibanchuli1",
    component: daibanchuli1
  },
  {
    path: "/daibanchuli2",
    component: daibanchuli2
  },
  {
    path: "/yibanchuli",
    component: yibanchuli
  },
  {
    path: "/yibanxuncha",
    component: yibanxuncha
  },
  {
    path: "/gaoweidaiban",
    component: daibanchuligaowei
  },
  {
    path: "/gaoweiyiban",
    component: yibangaowei
  },
  {
    path: "/yibanchuli1",
    component: yibanchuli1
  },
  {
    path: "/yibanchuli2",
    component: yibanchuli2
  },
  {
    path: "/yanghupaigong",
    component: yanghupaigong
  },
  {
    path: "/xunchapaigong",
    component: xunchapaigong
  },
  {
    path: "/xiaoxiupaigong",
    component: xiaoxiupaigong
  },
  {
    path: "/yingjipaigong",
    component: yingjipaigong
  },
  {
    path: "/gaoweishenqing2",
    component: gaoweishenqing
  }
];
export default data;



// WEBPACK FOOTER //
// ./src/router/yanghu.js